import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { NewApiUserService } from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly newApiUserService: NewApiUserService
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const isLoggedIn = await firstValueFrom(
      this.newApiUserService.currentUser$
    );

    if (!isLoggedIn) return true;

    this.router.navigate(['/']);
    return false;
  }

  async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
    const isLoggedIn = await firstValueFrom(
      this.newApiUserService.currentUser$
    );

    if (!isLoggedIn) return true;

    this.router.navigate(['/']);
    return false;
  }
}
